/*
 * @Author: wangbaihe
 * @Date: 2022-09-15 18:41:07
 * @LastEditors: wangbaihe
 * @LastEditTime: 2023-09-20 14:54:34
 * @FilePath: \common-mediax\src\apis\MediaCloudManageCenter\Discuss.js
 * @Description:
 */
// 发布端App端
import { createAPI } from '@common'

export default {
  // 旧------------------------------
  // 清除举报记录
  // postNisDiscussExposeClear: (config) =>
  //   createAPI('customEncryptApiName-1/0w20ojt0fyqptf0dmfbs', 'post', config),
  // 评论设置
  postNisDiscussConfig: (config) =>
    createAPI('customEncryptApiName-1/w20ojt0ejtdvtt0dpogjh', 'post', config),
  // getNisDiscussConfig: (config) =>
  //   createAPI('customEncryptApiName-1/w20ojt0ejtdvtt0dpogjh', 'get', config),
  // 评论内容详情
  // getNisDiscussContent: (config) =>
  //   createAPI('customEncryptApiName-1/0w20ojt0ejtdvtt0dpoufou', 'get', config, { neverLoading: true })
  // 新------------------------------
  // 评论内容详情
  getNisDiscussContent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0dpoufou', 'get', config, {
      neverLoading: true
    }),
  //查询帖子详情
  getNisCirclePostDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0qptu0efubjm', 'get', config),
  // 删除评论
  postNisDiscussDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0efmfuf', 'post', config),
  // 官方回复
  postNisDiscussReply: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0sfqmz', 'post', config),
  // 评论审核通过
  postNisDiscussPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0qbtt', 'post', config),
  // 评论审核不通过
  postNisDiscussReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0sfkfdu', 'post', config),
  // 保存评论设置
  postNisDiscussConfigSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0dpogjh', 'post', config),
  // 获取评论设置
  getNisDiscussConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0dpogjh', 'get', config),
  // 根据docId获取稿件详情
  getArticleDetailByDocId: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0ofx0efubjmCzEpdJe', 'get', config),
  // 清除举报记录
  postNisDiscussExposeClear: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0fyqptf0dmfbs', 'post', config),
  // 评论导出
  postNisDiscussExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0fyqpsu', 'post', config, {
      timeout: 12000000
    }),
  // 获取评论对应的稿件信息
  getNisDiscussArticleInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0bsujdmfJogp', 'GET', config),
  // 获取评论详情列表（包括回复）
  getNisDiscussReplyList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0sfqmzMjtu', 'GET', config),
  // 获取自动生成评论列表
  getNisDiscussAutoList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0ejtdvttMjtu', 'GET', config, {
      timeout: 120000
    }),
  // 自动生成评论
  discussCreate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0ejtdvttDsfbuf', 'post', config, {
      timeout: 120000
    }),
  getE5Actions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0f60bdujpot', 'get', config, vconfig),
}
